<template>
    <aside class='menu'>
        <p class='menu-label'>管理</p>
        <ul class='menu-list'>
            <li><router-link :to="{ path: '/admin' }">店舗管理</router-link></li>
            <li><router-link :to="{ path: '/admin/order' }">注文一覧</router-link></li>
            <!-- <li><router-link :to="{ path: '/admin/sales' }">売り上げ管理</router-link></li> -->
        </ul>
        <p class='menu-label'>設定</p>
        <ul class='menu-list'>
            <li><router-link :to="{ path: '/admin/setting' }">共通設定</router-link></li>
        </ul>
        <p class='menu-label'>その他</p>
        <ul class='menu-list'>
            <li @click='logout'><a class='has-text-danger'>ログアウト</a></li>
        </ul>
    </aside>
</template>

<script>

export default {
    name: 'Sidebar',
    components: {
    },
    data () {
        return {
        }
    },
    mounted () {
    },
    methods: {
        logout () {
            this.$root.$emit('logout')
        }
    }
}
</script>

<style scoped>
.menu {
    min-height: calc(100vh - 80px);
    min-width: 230px;
    padding-top: 20px;
    padding-left: 18px;
    padding-bottom: 10px;
    background-color: #fafafa;
}

.menu-label {
    font-size: 15px;
}

a {
    font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/Sidebar.vue